export default "__VITE_ASSET__de6e0cb5__"